module.exports = __webpack_public_path__ + "mk.svg?4a879fde847db3890fea5197ef3663d1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/mk.svg
// module id = 1241
// module chunks = 0